export enum SESSION {
  TOKEN = 'token',
  HEAD_SPLIT_TOKEN = 'headSplitToken',
}
